import { ReactComponent as Icon } from "../files/settings-icon.svg";
import { matchPath } from "react-router-dom";
import ISVGIconProps from "../ISVGIconProps";

const SettingsIcon = ({ fill, active, style = {}, path }: ISVGIconProps) => {
    const match = matchPath(
        {
            path: path ?? "NO_ADDRESS_PROVIDED",
        },
        window.location.pathname
    );
    return <Icon fill={match ? active : fill} style={style} />;
};

export default SettingsIcon;
